import { render, staticRenderFns } from "./TopicCourseWare.vue?vue&type=template&id=ceec0024&scoped=true&"
import script from "./TopicCourseWare.vue?vue&type=script&lang=js&"
export * from "./TopicCourseWare.vue?vue&type=script&lang=js&"
import style0 from "./TopicCourseWare.vue?vue&type=style&index=0&id=ceec0024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec0024",
  null
  
)

export default component.exports